var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 54,
    height: 54,
    rx: 27,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_10704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 30.08V31C40.9988 33.1564 40.3005 35.2547 39.0093 36.9818C37.7182 38.709 35.9033 39.9725 33.8354 40.5839C31.7674 41.1953 29.5573 41.1219 27.5345 40.3746C25.5117 39.6273 23.7846 38.2461 22.611 36.4371C21.4373 34.628 20.8798 32.4881 21.0217 30.3363C21.1636 28.1846 21.9972 26.1363 23.3983 24.4971C24.7993 22.8578 26.6928 21.7154 28.7962 21.2401C30.8996 20.7649 33.1003 20.9823 35.07 21.86M41 23L31 33.01L28 30.01",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 54,
    height: 54,
    rx: 27,
    stroke: "#F1F6FF",
    strokeWidth: 8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_10704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(19 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.0e1c857e.svg";
export { ForwardRef as ReactComponent };